import * as api from "Api";

class TasksApi {
  getLastUserActivities(uid, organizationId) {
    return api
      .fetchLastTaskByUser(uid, organizationId)
      .then(response => response.data.data);
  }

  fetchCalendarSettings(
    organizationId,
    collaboratorUid,
    collaboratorERPId,
    year
  ) {
    return api
      .getCollaboratorAbsenceCalendarSettings(
        organizationId,
        "", //collboratorId
        year,
        collaboratorUid,
        collaboratorERPId
      )
      .then(response => response.data.data);
  }
}

export default new TasksApi();



// WEBPACK FOOTER //
// ./src/services/TasksServices.js